export const enum ModelViewerPermissions {
  READ_MODEL_VIEWER_INDEX_PAGE = 'read_model_viewer_index_page',
  READ_MODEL_VIEWER_LIFESTYLE_GENERATOR = 'read_model_viewer_lifestyle_generator',
  READ_MODEL_VIEWER_CONFIGURATOR = 'read_model_viewer_configurator',
  READ_MODEL_VIEWER_CHATGPT_PROVIDER = 'read_model_viewer_chatgpt_provider',
  READ_MODEL_VIEWER_IMAGE_BACKGROUND = 'read_model_viewer_image_background',
  READ_MODEL_VIEWER_RENDER_GENERATOR = 'read_model_viewer_render_generator',
  READ_MODEL_VIEWER_LIFESTYLE_COMMAND = 'read_model_viewer_lifestyle_command',
  READ_MODEL_VIEWER_SILO_COMMAND = 'read_model_viewer_silo_command',
  READ_MODEL_VIEWER_CLOSE_UP_COMMAND = 'read_model_viewer_close_up_command',
  READ_MODEL_VIEWER_STUDIO_LIFESTYLE_COMMAND = 'read_model_viewer_studio_lifestyle_command'
}
